import styled from "@mui/material/styles/styled";
import Box from "../Box";
const BadgeBox = styled(Box)(({ badgeColor, textColor, height, iconProps, paddingX, borderRadius }) => {
  return {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: badgeColor,
    color: textColor,
    height: `${height}px`,
    minWidth: `${height}px`,
    padding: iconProps ? 0 : `0 ${paddingX}px`,
    borderRadius: `${borderRadius}px`
  };
});
export {
  BadgeBox
};
